import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const NotificationsFooter = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          color: "var(--soft-black-gray-scale-600)",
          fontWeight: "700",
          fontSize: "14px",
        }}
      >
        {t("notifications.footer.That_s_all_your_notifications")}
      </Typography>
      <Typography
        sx={{
          color: "var(--soft-black-gray-scale-600)",
          fontWeight: "700",
          fontSize: "14px",
        }}
      >
        {t("notifications.footer.from_the_last_30_days")}
      </Typography>
    </Box>
  );
};
